import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import api from '@/api'

import VueHighlightJS from 'vue-highlight.js';
import css from 'highlight.js/lib/languages/css';
import javascript from 'highlight.js/lib/languages/javascript';
import vue from 'vue-highlight.js/lib/languages/vue';

import 'highlight.js/styles/atom-one-dark.css'

Vue.use(VueHighlightJS, {
	// Register only languages that you want
	languages: {
		css,
		javascript,
    vue
	}
});

import { Button, Select, Form, FormItem, Input, Switch, Dropdown, DropdownMenu, DropdownItem, Option,
	OptionGroup, } from 'element-ui'
Vue.use(Button);
Vue.use(Select);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Switch);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Option);
Vue.use(OptionGroup);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$api = api;